import type { IconData } from './icon-data.js';

export interface IconProps {
  icon: IconData;
  size?: number;
  /** Read out by screen readers. Without it the icon is decorative and hidden from them. */
  label?: string;
  className?: string;
}

/** An inline Material Symbol. It takes the current text colour. */
export function Icon({ icon, size = 24, label, className }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={icon.viewBox}
      fill="currentColor"
      focusable="false"
      {...(label === undefined ? { 'aria-hidden': true } : { role: 'img', 'aria-label': label })}
    >
      {icon.d.map((path) => (
        <path key={path} d={path} />
      ))}
    </svg>
  );
}
